<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container job-copy-week-modal">
          <div class="modal-header">
            <slot name="header">
              Select Schedule and Week
            </slot>
          </div>
          <div class="modal-body">
            <slot name="body" v-if="ready">
              <div class="row">
                <div class="col-4">
                  <label for="round"
                    >Every {{ schedules[schedule_index].duration }} Week
                    Schedule to:
                  </label>
                </div>
                <div class="col-8">
                  <select
                    class="form-control"
                    ref="schedule_round_schedule"
                    v-model="selected_schedule"
                  >
                    <option
                      v-for="index in Number(schedules.length)"
                      :value="index - 1"
                      v-bind:key="index"
                      >Every {{ schedules[index - 1].duration }} Week
                      Schedule</option
                    >
                  </select>
                </div>
              </div>
              <div class="row">
                <div class="col-4">
                  <label for="round">Week {{ week_index + 1 }} to: </label>
                </div>
                <div class="col-8">
                  <select
                    class="form-control"
                    ref="schedule_round_week"
                    v-model="selected_week"
                  >
                    <option
                      v-for="index in Number(
                        schedules[selected_schedule].duration,
                      )"
                      :value="index - 1"
                      v-bind:key="index"
                      :disabled="
                        selected_schedule == schedule_index &&
                          index - 1 == week_index
                      "
                      >Week {{ index }}</option
                    >
                  </select>
                </div>
              </div>
            </slot>
          </div>

          <div class="modal-footer">
            <slot name="footer">
              <button class="btn btn-plt" @click="_save">
                Ok
              </button>
              <button class="btn btn-plt" @click="$emit('close')">
                Cancel
              </button>
            </slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "ScheduleWeekPicker",
  props: {
    schedule_index: {
      type: Number,
      default: -1,
    },
    week_index: {
      type: Number,
      default: -1,
    },
  },
  data: () => ({
    selected_schedule: -1,
    selected_week: -1,
    ready: false,
  }),
  computed: {
    ...mapState("schedule", ["schedules"]),
  },
  mounted: function() {
    this.$nextTick(function() {
      this.selected_week = this.week_index;
      this.selected_schedule = this.schedule_index;
      this.ready = true;
    });
  },
  methods: {
    _save() {
      if (this.selected_schedule < 0) {
        alert("please select a schedule");
        return;
      }
      if (this.selected_week < 0) {
        alert("please select a week");
        return;
      }
      if (
        this.selected_week == this.week_index &&
        this.selected_schedule == this.schedule_index
      ) {
        alert("please select a different week and or schedule");
        return;
      }

      this.$emit("schedule_and_week_selected", {
        schedule: this.selected_schedule,
        week: this.selected_week,
      });
    },
  },
  watch: {},
  components: {},
};
</script>
